

export const primaryColor = 'rgb(252, 87, 47)'